import { trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

export const NEW_ARRIVALS_CAROUSEL_TABS_TEST_NAME = 'HP_NewArrivals_April2026';

export const trackNewArrivalsCarouselTabsTest = (): void => {
    trackAbTestV2Variant(NEW_ARRIVALS_CAROUSEL_TABS_TEST_NAME);
};
